import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useResource, Resources } from "Translations/Resources";
import { NotificationsManagementPageContent } from "Components/Notifications/NotificationsManagement/NotificationManagementPageContent";

const NotificationsManagementPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.NotificationsManagement)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null,
      }}
    >
      <StyledPageWrapper>
        <div className="left-content">
          <NotificationsManagementPageContent />
        </div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export { NotificationsManagementPage };
